import type { Client, Pagination } from '@/types'

export type ClientsPage = {
  clients: Client[]
  pagination: Pagination
}

export async function fetchClientsPage(
  orgSlug: string,
  { page = 1, per = 30, q = '' }: { page?: number; per?: number; q?: string } = {}
): Promise<ClientsPage> {
  const params = new URLSearchParams({ page: String(page), per: String(per) })
  if (q.trim()) params.set('q', q.trim())

  const response = await fetch(`/${orgSlug}/clients?${params}`, {
    headers: { Accept: 'application/json' },
    credentials: 'same-origin'
  })
  if (!response.ok) {
    throw new Error('No se pudieron cargar los clientes')
  }

  const payload = await response.json()
  return {
    clients: payload.clients ?? [],
    pagination: payload.pagination ?? { page, per, total: 0, has_more: false }
  }
}

function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || ''
}

function flattenErrors(errors: Record<string, unknown> | undefined) {
  if (!errors) return {} as Record<string, string>
  return Object.fromEntries(
    Object.entries(errors).map(([key, value]) => [
      key,
      Array.isArray(value) ? String(value[0] ?? '') : String(value ?? '')
    ])
  )
}

export async function createClient(
  orgSlug: string,
  attrs: { name: string; phone: string; email?: string; notes?: string; whatsapp_opted_in?: boolean }
): Promise<{ client?: Client; errors?: Record<string, string> }> {
  const response = await fetch(`/${orgSlug}/clients`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken()
    },
    credentials: 'same-origin',
    body: JSON.stringify({ client: attrs })
  })
  const payload = await response.json().catch(() => ({}))
  if (response.ok) {
    return { client: payload.client }
  }
  return { errors: flattenErrors(payload.errors) }
}
